export enum UploadFolderEnum {
  ADMIN_LOGOS = 'admin/logos',
  COMPANIES_LOGOS = 'companies/logos',
  DRIVERS_LOGOS = 'drivers/logos',
  USERS_LOGOS = 'users/logos',
  FACILITIES_FILES = 'facilities/files',
  TRAILERS_FILES = 'trailers/files',
  TRUCKS_FILES = 'trucks/files',
  DRIVERS_DOCUMENTS = 'drivers/documents',
  TRAILERS_DOCUMENTS = 'trailers/documents',
  TRUCKS_DOCUMENTS = 'trucks/documents',
}
